import React, { useEffect, useState } from 'react';

import PlayerCard from '../../molecules/player-card/PlayerCard';
import { CategoryType } from '../../atoms/player/category/Category';
import { VideoInfoStatusType } from '../../atoms/player/video-info-status/VideoInfoStatus';
import { IconStatus } from '../../../typings/design-tokens';
import styles from '../../../utils/styles';
import './diretta-card.scss';

export interface IDirettaCard {
  assetId: number;
  videoStill: string;
  altImage?: string;
  channel: string;
  subChannel: string;
  title: string;
  isDesktop: boolean;
  isMenuOpen?: boolean;
  accessRequired?: boolean;
  navFilterallVisibility?: boolean;
  appType?: string;
}

const DirettaCard: React.FC<IDirettaCard> = ({
  assetId,
  videoStill = 'https://video.sky.it/assets/images/tg24-livestream-cover.jpg',
  altImage,
  channel,
  subChannel,
  title,
  accessRequired,
  navFilterallVisibility,
  appType,
  isDesktop,
}) => {
  const buttonState = appType ? (appType as IconStatus) : 'normal';
  const [playButtonState, setPlayButtonState] = useState<IconStatus>(buttonState);
  useEffect(() => {
    setPlayButtonState(accessRequired ? 'disabled' : buttonState);
  }, [accessRequired, buttonState]);

  useEffect(() => {
    if (appType) {
      setPlayButtonState(appType as IconStatus);
    }
  }, [appType]);
  return (
    <div className={styles('diretta-card')}>
      {
        <PlayerCard
          assetId={assetId}
          videoStill={videoStill}
          altImage={altImage}
          playButtonState={playButtonState}
          onSetCategoryType={(type: CategoryType) => {}}
          onSetVideoStatusType={(videoStatusType: VideoInfoStatusType) => {}}
          onSetIsHiddenVideoInfoStatus={(isHidden: boolean) => {}}
          title={title}
          isDesktop={isDesktop}
          navFilterallVisibility={navFilterallVisibility}
          isLiveVideo
        />
      }
    </div>
  );
};

export default DirettaCard;
